export default __webpack_public_path__ + "static/feature_01-270274db956faf03f969c935a1f6eecc.png";